 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/Cover'
 import BACK_COVER_TEXT from '@/components/Back_Cover_Text'
 import INTRODUCTION from '@/components/Introduction'
 import DEAR_READER from '@/components/Dear_Reader'
 import LOVE_1 from '@/components/love_1'
 import TITLE_PAGE from '@/components/Title_Page'
 import ABOUT_THE_AUTHOR from '@/components/About_the_Author'
 import DEDICATION from '@/components/Dedication'
 import CONTENTS from '@/components/Contents'
 import CHAPTER_ONE from '@/components/Chapter_One'
 import CHAPTER_TWO from '@/components/Chapter_Two'
 import CHAPTER_THREE from '@/components/Chapter_Three'
 import CHAPTER_FOUR from '@/components/Chapter_Four'
 import CHAPTER_FIVE from '@/components/Chapter_Five'
 import CHAPTER_SIX from '@/components/Chapter_Six'
 import CHAPTER_SEVEN from '@/components/Chapter_Seven'
 import CHAPTER_EIGHT from '@/components/Chapter_Eight'
 import CHAPTER_NINE from '@/components/Chapter_Nine'
 import CHAPTER_TEN from '@/components/Chapter_Ten'
 import CHAPTER_ELEVEN from '@/components/Chapter_Eleven'
 import CHAPTER_TWELVE from '@/components/Chapter_Twelve'
 import CHAPTER_THIRTEEN from '@/components/Chapter_Thirteen'
 import CHAPTER_FOURTEEN from '@/components/Chapter_Fourteen'
 import LOVE_2 from '@/components/love_2'
 import BPAHEARTWARMING from '@/components/BPAHeartwarming'
 import BPAMYREWARDS from '@/components/BPAMyRewards'
 import A_SNEAK_PEEK_AT_SYNDI_POWELL_NEXT_NOVEL from '@/components/A_Sneak_Peek_At_Syndi_Powell_Next_Novel'
 import EXCERPT_FROM_AFTER_THE_RODEO_BY_CLAIRE_MCEWEN from '@/components/Excerpt_from_After_the_Rodeo_by_Claire_McEwen'
 import COPYRIGHT from '@/components/Copyright'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/Contents",
 			"name" : "Contents",
 			"component" : CONTENTS
 		},
 		{
 			"path" : "/Chapter_One",
 			"name" : "Chapter_One",
 			"component" : CHAPTER_ONE
 		},
 		{
 			"path" : "/Chapter_Two",
 			"name" : "Chapter_Two",
 			"component" : CHAPTER_TWO
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js